import { getReq } from '../service/API'
import useSWR from 'swr'
import { ENDPOINTS } from '../service/ENDPOINTS'

export const useClinicianById = (projectId: string, userId: string) => {
  const p = userId ? ENDPOINTS.CLINICIANS.byClinicianId(projectId, userId) : ''
  const { data, error, mutate } = useSWR(p, getReq, { suspense: true })

  return {
    data: !data ? data : data.data,
    isLoading: !error && !data,
    isError: error,
    mutate: mutate,
  }
}
